/**
 * Generated from raldo-server's `functions/src/features/agent/domain/screens.json`. Do not hand-edit:
 * run `node scripts/sync-screens.mjs` to regenerate. `npm run lint:screens` fails if it drifts.
 */
export const SCREENS = [
  {
    id: 'home',
    title: 'Chat',
    path: ['Chat'],
    about: 'The chat with Raldo.',
    open: false,
  },
  {
    id: 'chats',
    title: 'Past chats',
    path: ['Chat', 'Past chats'],
    about: 'Every past conversation with Raldo.',
    open: true,
  },
  {
    id: 'chat',
    title: 'Conversation',
    path: ['Chat', 'Past chats', 'Conversation'],
    about: 'One past conversation with Raldo.',
    item: {
      kind: 'thread',
      param: 'id',
    },
    open: false,
  },
  {
    id: 'inbox',
    title: 'Inbox',
    path: ['Inbox'],
    about: 'Messages from Raldo: finished work, questions, proposals and failures, unread first.',
    open: true,
  },
  {
    id: 'inbox.sent',
    title: 'Sent',
    path: ['Inbox', 'Sent'],
    about: "The user's own notes: news, events and context Raldo uses in content.",
    open: true,
  },
  {
    id: 'inbox.archive',
    title: 'Archive',
    path: ['Inbox', 'Archive'],
    about: 'Messages the team has archived.',
    open: true,
  },
  {
    id: 'calendar',
    title: 'Board',
    path: ['Board'],
    about: 'Posts and pages with a date, week by week: drafts, scheduled and published.',
    open: true,
  },
  {
    id: 'calendar.canvas',
    title: 'Canvas',
    path: ['Board', 'Canvas'],
    about: 'The drafting workbench for posts.',
    open: true,
  },
  {
    id: 'calendar.schedule',
    title: 'Publishing schedule',
    path: ['Board', 'Publishing schedule'],
    about: 'The posting rhythm: posts per week, preferred days and times.',
    open: true,
  },
  {
    id: 'pages',
    title: 'Pages',
    path: ['Pages'],
    about:
      'Every page of the content plan by topic, and the plan run with its review when one is open.',
    open: true,
  },
  {
    id: 'page',
    title: 'Page',
    path: ['Pages', 'Page'],
    about:
      'One page in three tabs: Research (why it wins, questions for the user, sources), Draft (the article text and its checks) and Visibility (its searches, rank and AI answers).',
    item: {
      kind: 'page',
      param: 'id',
      lookup: {
        tool: 'listPlan',
        where: 'the id of each page',
      },
    },
    open: true,
  },
  {
    id: 'posts',
    title: 'Posts',
    path: ['Posts'],
    about: 'Every post, filtered by status: needs review, scheduled, published.',
    open: true,
  },
  {
    id: 'post',
    title: 'Post',
    path: ['Posts', 'Post'],
    about:
      'One post in three tabs: Research (what it argues and where it came from), Draft (its text, slides and schedule) and Visibility (its results).',
    item: {
      kind: 'post',
      param: 'id',
      lookup: {
        tool: 'listRecentContent',
        where: 'the id of each post',
      },
    },
    open: true,
  },
  {
    id: 'strategy',
    title: 'Arguments',
    path: ['Strategy', 'Arguments'],
    about:
      'The belief map: the core message and the arguments the brand makes, one belief at a time.',
    open: true,
  },
  {
    id: 'strategy.argument',
    title: 'Argument',
    path: ['Strategy', 'Argument'],
    about: 'One argument: its claim and the objection it defeats.',
    item: {
      kind: 'belief',
      param: 'slug',
      lookup: {
        tool: 'readDocument',
        where: 'slug "belief-map", the slug of each belief',
      },
    },
    open: true,
  },
  {
    id: 'strategy.topic',
    title: 'Topic',
    path: ['Pages', 'Topic'],
    about: 'One topic: what it covers and its pages in writing order.',
    item: {
      kind: 'topic',
      param: 'id',
      lookup: {
        tool: 'listPlan',
        where: 'the id of each topic',
      },
    },
    open: true,
  },
  {
    id: 'strategy.topic.research',
    title: 'Research',
    path: ['Pages', 'Topic', 'Research'],
    about:
      'The research of one topic: every fact traced to its original source, and the facts still waiting for one.',
    item: {
      kind: 'topic',
      param: 'id',
      lookup: {
        tool: 'listPlan',
        where: 'the id of each topic',
      },
    },
    open: true,
  },
  {
    id: 'strategy.research-entry',
    title: 'Research entry',
    path: ['Pages', 'Topic', 'Research', 'Research entry'],
    about:
      'One traced fact: its original source, the pages it was found on and the page sections that use it.',
    item: {
      kind: 'researchEntry',
      param: 'id',
      lookup: {
        tool: 'listResearch',
        where: 'the id of each entry',
      },
    },
    open: true,
  },
  {
    id: 'media.uploads',
    title: 'Uploads',
    path: ['Media', 'Uploads'],
    about: 'Images the user uploaded to the media library.',
    open: true,
  },
  {
    id: 'media.designs',
    title: 'Designs',
    path: ['Media', 'Designs'],
    about: 'Every design Raldo made.',
    open: true,
  },
  {
    id: 'media.templates',
    title: 'Templates',
    path: ['Media', 'Templates'],
    about: 'Templates for new designs.',
    open: true,
  },
  {
    id: 'design',
    title: 'Design',
    path: ['Media', 'Designs', 'Design'],
    about: 'One design and its pages.',
    item: {
      kind: 'design',
      param: 'designId',
      lookup: {
        tool: 'listDesigns',
        where: 'the id of each design',
      },
    },
    open: true,
  },
  {
    id: 'visibility',
    title: 'Rankings',
    path: ['Visibility', 'Rankings'],
    about:
      'Search rank of the main search of each live page, grouped by topic. A row opens the Visibility tab of its page.',
    open: true,
  },
  {
    id: 'visibility.ai-answers',
    title: 'AI answers',
    path: ['Visibility', 'AI answers'],
    about: 'How often AI assistants name or cite the brand, by prompt, topic and stage.',
    open: true,
  },
  {
    id: 'visibility.social',
    title: 'Social Media',
    path: ['Visibility', 'Social Media'],
    about: "The brand's own LinkedIn analytics.",
    open: true,
  },
  {
    id: 'visibility.prompt',
    title: 'Prompt',
    path: ['Visibility', 'AI answers', 'Prompt'],
    about: 'One prompt and how each assistant answered it.',
    item: {
      kind: 'prompt',
      param: 'promptId',
      lookup: {
        tool: 'listPrompts',
        where: 'the id of each prompt',
      },
    },
    open: true,
  },
  {
    id: 'competitors',
    title: 'Competitors',
    path: ['Competitors'],
    about: 'The other names buyers consider, and how the brand compares.',
    open: true,
  },
  {
    id: 'competitor',
    title: 'Competitor',
    path: ['Competitors', 'Competitor'],
    about: 'One competitor and how the brand compares to it.',
    item: {
      kind: 'competitor',
      param: 'id',
      lookup: {
        tool: 'listCompetitors',
        where: 'the id of each competitor',
      },
    },
    open: true,
  },
  {
    id: 'identity.brand-facts',
    title: 'Brand facts',
    path: ['Profile', 'Brand facts'],
    about: 'What the company sells, read from its own pages.',
    open: true,
  },
  {
    id: 'identity.customer-profile',
    title: 'Customer profile',
    path: ['Profile', 'Customer profile'],
    about: 'Who the customers are and what they say.',
    open: true,
  },
  {
    id: 'style.voice',
    title: 'Voice',
    path: ['Style', 'Voice'],
    about: 'The Style Guide: how the brand writes.',
    open: true,
  },
  {
    id: 'style.look',
    title: 'Visual style',
    path: ['Style', 'Visual style'],
    about: 'The Visual Style: colours, type, logo and monogram.',
    open: true,
  },
  {
    id: 'documents',
    title: 'Knowledge',
    path: ['Knowledge'],
    about: 'Knowledge pages: what is true about the product.',
    open: true,
  },
  {
    id: 'document',
    title: 'Knowledge page',
    path: ['Knowledge', 'Knowledge page'],
    about: 'One knowledge page.',
    item: {
      kind: 'knowledgePage',
      param: 'slug',
      lookup: {
        tool: 'listKnowledge',
        where: 'the slug of each page',
      },
    },
    open: true,
  },
  {
    id: 'settings.account',
    title: 'Account',
    path: ['Settings', 'Account'],
    about: "The user's own profile.",
    open: true,
  },
  {
    id: 'settings.billing',
    title: 'Billing',
    path: ['Settings', 'Billing'],
    about: 'The subscription plan and its billing.',
    open: true,
  },
  {
    id: 'settings.connections',
    title: 'Connections',
    path: ['Settings', 'Connections'],
    about: 'Connected social accounts.',
    open: true,
  },
  {
    id: 'setup',
    title: 'Setup',
    path: ['Setup'],
    about: "Brand setup: the five steps that build the brand's foundation.",
    item: {
      kind: 'setupStep',
      param: 'step',
    },
    open: false,
  },
] as const

/** The kind of record an item screen shows. */
export type ScreenItemKind = Extract<(typeof SCREENS)[number], { item: unknown }>['item']['kind']

/** One screen of the app, as the server catalogue describes it. */
export interface Screen {
  readonly id: string
  readonly title: string
  readonly path: readonly string[]
  readonly about: string
  readonly item?: {
    readonly kind: ScreenItemKind
    readonly param: string
    readonly lookup?: { readonly tool: string; readonly where: string }
  }
  readonly open: boolean
}

export type ScreenId = (typeof SCREENS)[number]['id']

/** A screen the agent may ask the client to open. */
export type OpenScreenId = Extract<(typeof SCREENS)[number], { open: true }>['id']

export const OPEN_SCREEN_IDS = SCREENS.filter((screen) => screen.open).map(
  (screen) => screen.id,
) as readonly OpenScreenId[]

/** Returns the screen with this id, or `undefined` for an unknown id. */
export function findScreen(id: string): Screen | undefined {
  return (SCREENS as readonly Screen[]).find((screen) => screen.id === id)
}
